// For full API documentation, including code examples, visit http://wix.to/94BuAAs
let fullText; // variable to hold the full text
let shortText; // variable to hold the short version of the text

$w.onReady(function () {
	// how many characters to include in the shortened version
const shortTextLength = 540;
// read the full text and store it in the fullText variable
fullText = $w("#text128").text;
// grab the number of characters defined in shortTextLength and store them in the shortText variable
shortText = fullText.substr(0, shortTextLength) + "...";
// set the contents of the text element to be the short text
$w("#text128").text = shortText;
//TODO: write your page related code here...

});

export function button10_click(event) {
	// display the full text
$w("#text128").text = fullText;
// collapse the button
$w("#button10").collapse();
//Add your code for this event here: 
}